import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {IonContent, IonSearchbar, Platform, ModalController, LoadingController, IonModal} from '@ionic/angular';
import {of, Subscription} from 'rxjs';
import {catchError, filter, map, switchMap, take} from 'rxjs/operators';
import {UnrApiService} from '../../core/api/api.service';
import {Roadtrip} from '../../core/api/resources/roadtrip-list.resource';
import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {UnrSettingsService} from '../../services/settings/settings.service';
import {UnrRouteListItem} from './roadtrip-list-item/model/route-list-item.model';

import {DOCUMENT} from '@angular/common';
import {SliderService} from '../welcome/slider.service';
import {UnrGoogleMapComponent} from '../../shared/maps/components/google-map/google-map.component';
import { AdsmodalPage } from 'src/app/adsmodal/adsmodal.page';
import { UnrAuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'unr-roadtrip-list-page',
  templateUrl: './roadtrip-list.page.html',
  styleUrls: ['./roadtrip-list.page.scss']
})
export class RoadtripListPage implements OnInit, OnDestroy, AfterViewInit {

  tripsCopy: UnrRouteListItem[];
  trips: UnrRouteListItem[];

  @ViewChild('content', {static: false}) content: IonContent;
  @ViewChild('searchBar', {static: false}) searchbar: IonSearchbar;
  @ViewChild('addHomeModal', { static: true }) modal!: IonModal;
  showModal = false;

  private routerSubscription: Subscription;

  constructor(private api: UnrApiService,
              private settings: UnrSettingsService,
              private router: Router,
               private authService: UnrAuthService,
              private statusbarService: StatusbarService,
              @Inject(DOCUMENT)
              private document: Document,
              private sliderService: SliderService,
              
                  private modalCtrl: ModalController,
              private platform: Platform) {
                  
  }

  async ionViewWillEnter(): Promise<void> {
  
    this.sliderService.resetSlider();
  }
  
 closeModal() {
    this.showModal = false;
  }
  async ionViewDidEnter() {
  const isMobileBrowser = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  if (!isMobileBrowser) return;
  
  await this.showAdsPopup();
}
  ngOnInit(): void {
    
    this.document.body.style.background = '#fff';
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        filter((event: NavigationEnd) => event.urlAfterRedirects === '/roadtrips/list')
      )
      .subscribe(p => {
        this.searchbar.value = '';
        if (this.platform.is('ios')) {
          this.statusbarService.changeStatusBar({ style: ''});
        } else {
          this.statusbarService.changeStatusBar({ style: ''});
        }
        this.statusbarService.changeBgColor('#80000000');
        this.getTrips();
      });
  }
async showAdsPopup() {
  const modal = await this.modalCtrl.create({
    component: AdsmodalPage,
    backdropDismiss: true,
    showBackdrop: true,
    cssClass: 'modal--popup'
  });

  await modal.present();

  const { data } = await modal.onDidDismiss();

  // Ads finished → now show Add-to-Home
  if (data?.showAddToHome) {
    // small delay so Ionic fully clears overlay stack
    setTimeout(() => {
      this.showModal = true;
    }, 300);
  }
}

  ngOnDestroy(): void {
    this.routerSubscription && this.routerSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.searchbar
      .getInputElement()
      .then((searchbarInputElement) => {
        searchbarInputElement.style.boxShadow = 'none';
        searchbarInputElement.style.border = '1px solid #14213D';
        searchbarInputElement.style.borderRadius = '5px';
      });
  }

  trackByFn(index, roadTrip: Roadtrip) {
    return roadTrip.id;
  }

onChange(event): void {
  let value = event.detail.value?.trim().toLowerCase() || '';

  // If empty or less than 3 chars → reset full list
  if (value.length < 3) {
    this.trips = this.tripsCopy;
    return;
  }

  // Filter after 3+ characters
  this.trips = this.tripsCopy.filter(trip =>
    trip.country.toLowerCase().includes(value) ||
    trip.title.toLowerCase().includes(value)
  );
}


  private getTrips(): void {
    this.settings.getKmOrMiles()
      .pipe(
        switchMap((kmOrMiles) => this.api.getRoadTripList(kmOrMiles)),
        map(async response => {
           console.log(response);
            this.trips = response.roadTrips.map((roadTrip) => {
              return {
                country: roadTrip.country,
                iconName: roadTrip.label,
                details: roadTrip.description,
                distance: roadTrip.distance,
                imgPath: roadTrip.mainImageFile,
                title: roadTrip.tripName,
                id: roadTrip.id
              } as UnrRouteListItem;
            });
            this.tripsCopy = [...this.trips];
              console.log('called');
            await this.authService.hideLoadingIndicator();
            
          }
        ),
        catchError(err => of([]))
      ).pipe(take(1)).subscribe();
  }
}
